import { Tooltip, Typography } from '@mui/material'
import type { Timestamp } from 'firebase/firestore'
import { formatRelativeTime } from 'src/utils/device'
import { formatTimestamp } from 'src/utils/firebase'

type LastSeenProps = {
  timestamp?: Timestamp | null
}

// 最終通信日時を相対表記で表示する。絶対日時はツールチップで確認できる。
export const LastSeen = ({ timestamp }: LastSeenProps) => {
  if (!timestamp) {
    return (
      <Typography
        variant="body2"
        sx={{
          color: 'text.secondary',
        }}
      >
        通信なし
      </Typography>
    )
  }

  return (
    <Tooltip title={formatTimestamp(timestamp)}>
      <Typography variant="body2" component="span">
        {formatRelativeTime(timestamp.toDate())}
      </Typography>
    </Tooltip>
  )
}
